import React from "react";

import styled from "styled-components";

import * as Statuses from "~/components/icons/Statuses";

type VASPVerificationStatus = "PENDING" | "VERIFIED" | "UNVERIFIED" | null | undefined;

export default styled(({ status, ...props }: { status?: VASPVerificationStatus }) => {
  switch (status) {
    case "VERIFIED": {
      return <Statuses.Verified {...props} />;
    }

    default: {
      return null;
    }
  }
})`
  margin-right: 4px;
`;
